import { BETSLIP_STATUS, ITEM_TYPES } from 'bto-models/betslip';

export default {
  data() {
    return {
      PLACED: BETSLIP_STATUS.PLACED,
      WON: BETSLIP_STATUS.WON,
      LOST: BETSLIP_STATUS.LOST,
      REJECTED: BETSLIP_STATUS.REJECTED,
      CANCELED: BETSLIP_STATUS.CANCELLED,
      CASHED_OUT: BETSLIP_STATUS.CACHEDOUT,
      PAID: BETSLIP_STATUS.PAID,
      PENDING: BETSLIP_STATUS.PENDING,
      VOID: BETSLIP_STATUS.VOID,
      LIVE: ITEM_TYPES.LIVE,
      BET_BUILDER: ITEM_TYPES.BET_BUILDER,
      BOOSTED_ODD: ITEM_TYPES.BOOSTED_ODD,
      ALGO: ITEM_TYPES.ALGO,
    };
  },
  props: {
    betDetails: {
      type: Object,
      required: true,
    },
    notTopWinnings: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showTotalOdds() {
      return false;
    },
  },
  methods: {
    checkGroupStatus(status) {
      return this.betDetails.betSlipGroupStatusId === status;
    },
    checkCombStatus(comb, status) {
      return comb.combinationStatusId === status;
    },
    checkEventStatus(event, status) {
      return event.itemStatusId === status;
    },
    checkMatchType(event, type) {
      return event.itemTypeId === type;
    },
    isEventLive(event) {
      return event.itemTypeId === ITEM_TYPES.LIVE || event.itemTypeId === ITEM_TYPES.LIVE_PLAYER_SWISH;
    },
    hasChanged(str) {
      return `${str}`.includes('t');
    },
  },
};